// extracted by css-extract-rspack-plugin
export default {"Box":"iteration-renderer-module__Box__VXl8EAk","Label":"iteration-renderer-module__Label__I9568Mu"};